import { Power4 } from 'gsap';
import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import Head from 'next/head';
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import { Timeline, Tween } from 'react-gsap';
import { Controller, Scene } from 'react-scrollmagic';
import getMetaTagData from '../../src/common/services/getMetaTagData';

function SbsPlay({ metaTagData, jWTCheck }) {
  const [ScrollY, setScrollY] = useState(0);
  const [height, setHeight] = useState(0);

  const handleFollow = () => {
    document.querySelector('.sbsplayAboutTop_w').classList.add('fadeIn');

    setScrollY(window.pageYOffset);
    setHeight(window.innerHeight);
  };

  useEffect(() => {
    setHeight(window.innerHeight);

    const fadeIn = document.querySelectorAll('.fadeIn');
    fadeIn.forEach((fadein) => {
      if (ScrollY > fadein.offsetTop - height / 1.1) {
        fadein.classList.add('active');
      } else {
        fadein.classList.remove('active');
      }
    });

    const video = document.querySelector('.sbsplayAboutVideo');
    if (ScrollY < 100) {
      video.classList.remove('video_moving');
    } else {
      video.classList.add('video_moving');
    }
  }, [ScrollY, height]);

  useEffect(() => {
    const watch = () => {
      window.addEventListener('scroll', handleFollow);
    };
    watch();
    return () => {
      window.removeEventListener('scroll', handleFollow);
    };
  });

  useEffect(() => {
    const popupElements = document.querySelectorAll('.aboutMapCont_w > a');
    const aboutMapCont = document.querySelectorAll('.aboutMapCont_w');

    [].forEach.call(popupElements, (element) => {
      element.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          aboutMapCont.forEach((cont) => {
            cont.classList.remove('current');
          });
          e.target.closest('.aboutMapCont_w').classList.add('current');
        },
        false
      );
    });

    const closeBtns = document.querySelectorAll('.aboutLayerBtn_closed');

    [].forEach.call(closeBtns, (element) => {
      element.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          aboutMapCont.forEach((cont) => {
            cont.classList.remove('current');
          });
        },
        false
      );
    });
  }, []);

  return (
    <>
      <Head>
        <link
          key="css_pc_url"
          rel="stylesheet"
          href={`${process.env.NEXT_PUBLIC_GLOBAL_CSS_2023_PC_URL}?v=${process.env.NEXT_PUBLIC_BUILD_TIME}`}
        />
        <meta
          key="viewport"
          name="viewport"
          content="width=device-width, initial-scale=1"
        />
        <script
          key="gnb_js_url"
          type="text/javascript"
          src={process.env.NEXT_PUBLIC_GNB_JS_URL}
        />

        <meta name="description" content={metaTagData.shareDescription} />
        <meta name="keywords" content={metaTagData.keywords} />
        <meta name="twitter:card" content="summary" />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="ko_KR" />
        <meta property="og:site_name" content="SBS" />
        <meta property="og:title" content={metaTagData.shareTitle || ''} />
        <meta
          property="og:description"
          content={metaTagData.shareDescription || ''}
        />
        <meta property="og:image" content={metaTagData.shareImageUrl || ''} />
        <meta property="og:url" content={metaTagData.currentUrl || ''} />
        <meta name="nate:site_name" content="SBS" />
        <meta name="nate:title" content={metaTagData.shareTitle || ''} />
        <meta
          name="nate:description"
          content={metaTagData.shareDescription || ''}
        />
        <meta name="nate:image" content={metaTagData.shareImageUrl || ''} />
        <meta name="nate:url" content={metaTagData.currentUrl || ''} />
        <title>{metaTagData.shareTitle}</title>
      </Head>

      <div id="container" className="contents_sbsplay">
        <div className="sbsplayAboutContents animationType">
          {/*<!-- 페이지 명 클래스  -->*/}
          <Controller>
            <Scene
              duration="100%"
              triggerElement="#PC1"
              triggerHook="onLeave"
              pin
            >
              {(progress) => (
                <div id="PC1">
                  <div className="sbsplayAboutTop_w">
                    <strong className="sbsplayAboutTop_title">
                      SBS 홈페이지의 새로운 브랜드
                    </strong>
                    <em className="sbsplayAboutTop_logo">
                      <img src="/images/about_sbsplay_logo.png" alt="" />
                    </em>
                  </div>
                  {/*<!-- scene1 -->*/}
                  <div className="sbsplayAboutVideo_w">
                    <Tween
                      from={{
                        duration: 1,
                        css: {
                          opacity: 1,
                        },
                        ease: 'Power4.easeInOut',
                      }}
                      to={{
                        duration: 1,
                        css: {
                          width: 1200,
                        },
                        ease: 'Power4.easeInOut',
                      }}
                      totalProgress={progress}
                      paused
                    >
                      <div className="sbsplayAboutVideo">
                        <video
                          autoPlay={'autoplay'}
                          muted
                          controls
                          src="/images/@video.mp4"
                          loop={false}
                        ></video>
                        {/*<!--<img src="https://via.placeholder.com/220x50" alt="" />-->*/}
                      </div>
                    </Tween>
                  </div>
                </div>
              )}
            </Scene>
          </Controller>
          <div className="sbsplayAboutMiddle_w">
            {/*<!-- scene2 -->*/}
            <div className="sbsplayAbout_contBox">
              <strong className="aboutCont-title fadeIn">
                SBS 방송 콘텐츠와 다채로운 서비스를 통해
                <br />
                끊임없이 즐거움을 이어가자는 의미를 담고있어요.
              </strong>
              <div className="aboutCont-image fadeIn">
                <img src="/images/slogan.png" alt="" />
              </div>
              <p className="aboutCont-text fadeIn">
                유기적이고 동적인 용수철 모티브로 'play'와 '즐거움을 잇다!'
                문자를 곡선화하고
                <br />
                '낙천적'을 상징하는 핑크와 '새로움'을 상징하는 보라색으로
                <br />
                SBS play 브랜드의 즐거움이 이어지는 의미와 생동감을 표현했어요.
              </p>
            </div>
            {/*<!-- scene3 -->*/}
            <div className="sbsplayAbout_contBox ">
              <strong className="aboutCont-title fadeIn">
                SBS play를 즐기는 사람들
              </strong>
              <p className="aboutCont-text fadeIn">
                공통의 관심사를 함께 공감하고 소통하며
                <br />
                SBS play에서 즐거움을 이어가세요.
              </p>
            </div>
          </div>
          <div className="sbsplayAboutEpilogue_w">
            <div className="aboutCont-image fadeIn">
              <img
                src="/images/keyword.png"
                alt="즐거움, 함께, 연결, 도전적인, 친구, 행복한, 다채로운"
              />
            </div>
            <div className="aboutEpilogueBox_Left fadeIn">
              <div className="aboutEpilogue-message">
                <img
                  className="aboutEpilogue-Text"
                  src="/images/epilogue01_txt.png"
                  alt=""
                />
              </div>
              <img
                className="aboutEpilogue-image"
                src="/images/epilogue01.png"
                alt=""
              />
            </div>

            <div className="aboutEpilogueBox_right fadeIn">
              <div className="aboutEpilogue-message">
                <img
                  className="aboutEpilogue-Text"
                  src="/images/epilogue02_txt.png"
                  alt=""
                />
              </div>
              <img
                className="aboutEpilogue-image"
                src="/images/epilogue02.png"
                alt=""
              />
            </div>
            <div className="aboutEpilogueBox_Left fadeIn">
              <div className="aboutEpilogue-message">
                <img
                  className="aboutEpilogue-Text"
                  src="/images/epilogue03_txt.png"
                  alt=""
                />
              </div>
              <img
                className="aboutEpilogue-image"
                src="/images/epilogue03.png"
                alt=""
              />
            </div>
          </div>
          <div className="sbsplayAboutBottom_w">
            <strong className="aboutCont-title">
              SBS play에서
              <br />
              다채로운 즐거움을 만나보세요!
            </strong>
            <div
              className="aboutLinkMap_w"
              style={{ backgroundImage: `url('/images/bg_line.png')` }}
            >
              <div className="aboutLinkMap_inner">
                {/*<!-- AllVOD -->*/}
                <div className="aboutMapCont_w">
                  <a className="aboutLink_allvod">
                    <div className="motionTitle_w">
                      <img src="/images/allvod_text.png" alt="AllVOD" />
                    </div>
                    <img
                      src="/images/cp_allvod.png"
                      className="aboutLink_img"
                      alt=""
                    />
                  </a>
                  <div className="aboutLayer_w">
                    <strong className="aboutLayer_title">AllVOD</strong>
                    <p className="aboutLayer_text">
                      10만여 개의 영상을
                      <br />
                      무료로 즐기는 가장 좋은 방법
                    </p>
                    <div className="aboutLayerTag_w">
                      <span className="aboutLayerTag">#VOD</span>
                      <span className="aboutLayerTag">#구작</span>
                    </div>
                    <a
                      href="https://allvod.sbs.co.kr"
                      target="_blank"
                      className="aboutLayer_link"
                    >
                      서비스 바로가기
                    </a>
                    <button type="button" className="aboutLayerBtn_closed">
                      <span className="iconSvg_closed">
                        <i className="hide">레이어닫기</i>
                      </span>
                    </button>
                  </div>
                </div>
                {/*<!-- 플레이톡 -->*/}
                <div className="aboutMapCont_w">
                  <a className="aboutLink_playtalk">
                    <div className="motionTitle_w">
                      <img src="/images/playtalk_text.png" alt="플레이톡" />
                    </div>
                    <img
                      src="/images/cp_playtalk.png"
                      className="aboutLink_img"
                      alt=""
                    />
                  </a>
                  <div className="aboutLayer_w">
                    <strong className="aboutLayer_title">플레이톡</strong>
                    <p className="aboutLayer_text">
                      함께 보고 소통하는 즐거움!
                      <br />
                      SBS 전용 커뮤니티에서 톡하자
                    </p>
                    <div className="aboutLayerTag_w">
                      <span className="aboutLayerTag">#함께</span>
                      <span className="aboutLayerTag">#커뮤니티</span>
                    </div>
                    <a
                      href="https://www.sbs.co.kr/playtalk"
                      target="_blank"
                      className="aboutLayer_link"
                    >
                      서비스 바로가기
                    </a>
                    <button type="button" className="aboutLayerBtn_closed">
                      <span className="iconSvg_closed">
                        <i className="hide">레이어닫기</i>
                      </span>
                    </button>
                  </div>
                </div>
                {/*<!-- 라이브 -->*/}
                <div className="aboutMapCont_w">
                  <a className="aboutLink_live">
                    <div className="motionTitle_w">
                      <img src="/images/live_text.png" alt="라이브" />
                    </div>
                    <img
                      src="/images/cp_live.png"
                      className="aboutLink_img"
                      alt=""
                    />
                  </a>
                  <div className="aboutLayer_w">
                    <strong className="aboutLayer_title">라이브</strong>
                    <p className="aboutLayer_text">
                      생생한 라이브 방송을
                      <br />
                      SBS play 에서 더 편하게 보자!
                    </p>
                    <div className="aboutLayerTag_w">
                      <span className="aboutLayerTag">#LIVE</span>
                      <span className="aboutLayerTag">#소통</span>
                    </div>
                    <a
                      href="https://www.sbs.co.kr/live"
                      target="_blank"
                      className="aboutLayer_link"
                    >
                      서비스 바로가기
                    </a>
                    <button type="button" className="aboutLayerBtn_closed">
                      <span className="iconSvg_closed">
                        <i className="hide">레이어닫기</i>
                      </span>
                    </button>
                  </div>
                </div>
                {/*<!-- 프로그램 홈페이지 -->*/}
                <div className="aboutMapCont_w">
                  <a className="aboutLink_program">
                    <div className="motionTitle_w">
                      <img
                        src="/images/program_text.png"
                        alt="프로그램 홈페이지"
                      />
                    </div>
                    <img
                      src="/images/cp_program.png"
                      className="aboutLink_img"
                      alt=""
                    />
                  </a>
                  <div className="aboutLayer_w">
                    <strong className="aboutLayer_title">
                      프로그램 홈페이지
                    </strong>
                    <p className="aboutLayer_text">
                      프로그램 주요정보를 보고 싶다면?
                      <br />
                      소식부터 정보까지 빨리 공유해줄께!
                    </p>
                    <div className="aboutLayerTag_w">
                      <span className="aboutLayerTag">#생생정보통</span>
                      <span className="aboutLayerTag">#인물관계도</span>
                    </div>
                    <a
                      href="https://www.sbs.co.kr/tv"
                      target="_blank"
                      className="aboutLayer_link"
                    >
                      서비스 바로가기
                    </a>
                    <button type="button" className="aboutLayerBtn_closed">
                      <span className="iconSvg_closed">
                        <i className="hide">레이어닫기</i>
                      </span>
                    </button>
                  </div>
                </div>
                {/*<!-- 스브스노리터 -->*/}
                <div className="aboutMapCont_w">
                  <a className="aboutLink_playground">
                    <div className="motionTitle_w">
                      <img
                        src="/images/playground_text.png"
                        alt="스브스노리터"
                      />
                    </div>
                    <img
                      src="/images/cp_playground.png"
                      className="aboutLink_img"
                      alt=""
                    />
                  </a>
                  <div className="aboutLayer_w">
                    <strong className="aboutLayer_title">스브스노리터</strong>
                    <p className="aboutLayer_text">
                      방송이 더 재밌어지는
                      <br />
                      우리들의 노리터
                    </p>
                    <div className="aboutLayerTag_w">
                      <span className="aboutLayerTag">#놀자</span>
                      <span className="aboutLayerTag">#방송콘텐츠</span>
                    </div>
                    <a
                      href="https://programs.sbs.co.kr/special/pdnote/multiboards/65942"
                      target="_blank"
                      className="aboutLayer_link"
                    >
                      서비스 바로가기
                    </a>
                    <button type="button" className="aboutLayerBtn_closed">
                      <span className="iconSvg_closed">
                        <i className="hide">레이어닫기</i>
                      </span>
                    </button>
                  </div>
                </div>
                {/*<!-- 이벤트 -->*/}
                <div className="aboutMapCont_w">
                  <a className="aboutLink_event">
                    <div className="motionTitle_w">
                      <img src="/images/event_text.png" alt="이벤트" />
                    </div>
                    <img
                      src="/images/cp_event.png"
                      className="aboutLink_img"
                      alt=""
                    />
                  </a>
                  <div className="aboutLayer_w">
                    <strong className="aboutLayer_title">이벤트</strong>
                    <p className="aboutLayer_text">
                      SBS 홈페이지에서만 즐길 수 있는
                      <br />
                      방송 관련 이벤트들과 방청신청을 한번에!
                    </p>
                    <div className="aboutLayerTag_w">
                      <span className="aboutLayerTag">#프로그램이벤트</span>
                      <span className="aboutLayerTag">#방청신청</span>
                    </div>
                    <a
                      href="https://www.sbs.co.kr/event"
                      target="_blank"
                      className="aboutLayer_link"
                    >
                      서비스 바로가기
                    </a>
                    <button type="button" className="aboutLayerBtn_closed">
                      <span className="iconSvg_closed">
                        <i className="hide">레이어닫기</i>
                      </span>
                    </button>
                  </div>
                </div>
                {/*<!-- 스타 서비스 -->*/}
                <div className="aboutMapCont_w">
                  <a className="aboutLink_star">
                    <div className="motionTitle_w">
                      <img src="/images/star_text.png" alt="스타 서비스" />
                    </div>
                    <img
                      src="/images/cp_star.png"
                      className="aboutLink_img"
                      alt=""
                    />
                  </a>
                  <div className="aboutLayer_w">
                    <strong className="aboutLayer_title">스타 서비스</strong>
                    <p className="aboutLayer_text">
                      팬들의 신청과 투표로 진행되는 이달의 스타!
                      <br />
                      팬심공감 서비스 여기 다 있네!
                    </p>
                    <div className="aboutLayerTag_w">
                      <span className="aboutLayerTag">#나만의스타</span>
                      <span className="aboutLayerTag">#커뮤니티</span>
                    </div>
                    <a
                      href="https://star.sbs.co.kr/main/index.html"
                      target="_blank"
                      className="aboutLayer_link"
                    >
                      서비스 바로가기
                    </a>
                    <button type="button" className="aboutLayerBtn_closed">
                      <span className="iconSvg_closed">
                        <i className="hide">레이어닫기</i>
                      </span>
                    </button>
                  </div>
                </div>
                {/*<!-- 포토 서비스 -->*/}
                <div className="aboutMapCont_w">
                  <a className="aboutLink_photo">
                    <div className="motionTitle_w">
                      <img src="/images/photo_text.png" alt="포토 서비스" />
                    </div>
                    <img
                      src="/images/cp_photo.png"
                      className="aboutLink_img"
                      alt=""
                    />
                  </a>
                  <div className="aboutLayer_w">
                    <strong className="aboutLayer_title">포토 서비스</strong>
                    <p className="aboutLayer_text">
                      초고화질 사진부터 나의 최애 현장포토를
                      <br />
                      가장 빠르게 확인
                    </p>
                    <div className="aboutLayerTag_w">
                      <span className="aboutLayerTag">#최애</span>
                      <span className="aboutLayerTag">#현장포토</span>
                    </div>
                    <a
                      href="https://star.sbs.co.kr/menu_photolist/index.html"
                      target="_blank"
                      className="aboutLayer_link"
                    >
                      서비스 바로가기
                    </a>
                    <button type="button" className="aboutLayerBtn_closed">
                      <span className="iconSvg_closed">
                        <i className="hide">레이어닫기</i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="bannerEvent_w">
              <a href="/playzone/event" className="bannerEvent_link">
                <img
                  src="/images/playzone_bnr01.png"
                  alt="엄청난 상품과 함께 돌아온 SBS play  브랜드 오픈 이벤트2"
                />
              </a>
              <i
                className="bannerEvent_bg"
                style={{ backgroundColor: '#FAE4ED' }}
              ></i>
            </div> */}
            <div className="bannerSurvey_w">
              <div className="bannerSurvey_inner">
                <p className="bannerSurvey-title">
                  SBS play에 대한 소중한 의견을 남겨주세요!
                </p>
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSeiPK4cfR28WIiKZ5-RAzdZIzcCrnHHsHedJByxrJhdk8ZuSw/viewform"
                  target="_blank"
                  className="bannerSurvey-link"
                >
                  설문 참여하기
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export async function getServerSideProps(ctx) {
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { pageSection, pageCategory } = ctx.query;
  const { cookies } = ctx.req;
  const { LOGIN_JWT } = cookies;

  const jWTCheck = !!LOGIN_JWT;
  const metaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory);

  return { props: { metaTagData, jWTCheck } };
}

export default SbsPlay;
